import React from 'react';
import SimpleHeader from 'components/SimpleHeader';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';


export default function TermsOfServicePage() {
    const navigate = useNavigate();

    return (
        <div className="bg-background text-foreground min-h-screen">
            <SimpleHeader />

            {/* Sayfanın header altına oturması için margin-top */}
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-[80px] mb-10">

                <article
                    className="
            prose prose-base sm:prose-lg lg:prose-lg 
            max-w-none leading-relaxed 
            prose-headings:font-semibold 
            prose-h2:text-xl sm:prose-h2:text-2xl 
            prose-h3:text-lg sm:prose-h3:text-xl 
            prose-h2:mb-2 sm:prose-h2:mb-3 
            prose-h3:mb-1 sm:prose-h3:mb-2 
            prose-a:text-rose-600 hover:prose-a:text-rose-700 
            prose-strong:text-gray-800
          "
                >
                    <h1 className="text-2xl sm:text-3xl font-bold mb-2">
                        Anora Kullanım Koşulları
                    </h1>
                    <p className="lead text-gray-500 -mt-1 text-sm sm:text-base">
                        Son Güncelleme Tarihi: 17 Eylül 2025
                    </p>
                    <h2>1. Giriş</h2>
                    <p>
                        Bu Kullanım Koşulları, Anora Forever Yazılım ve Reklam Organizasyon Limited Şirketi tarafından sunulan anoraforever.com (“Platform”) kullanımını düzenler. Platformu kullanarak, bu koşulları kabul etmiş sayılırsınız. Eğer bu koşulları kabul etmiyorsanız, lütfen Platformu kullanmayınız.
                    </p>

                    <h2>2. Hizmetlerin Kullanımı</h2>
                    <p>Platformu yalnızca yasal amaçlarla ve bu Kullanım Koşulları'na uygun olarak kullanmayı kabul edersiniz. Aşağıdaki durumlarda hizmetlerimizi kullanmaktan kaçınmalısınız:</p>
                    <ul>
                        <li>Yasa dışı, hileli veya kötü niyetli bir amaç için.</li>
                        <li>Diğer kullanıcıların hizmetlere erişimini engellemek veya bozmak için.</li>
                        <li>Platformun veya kullanıcıların bilgilerini toplamak, saklamak veya işlemek için.</li>
                    </ul>

                    <h2>3. Hesap Oluşturma ve Güvenlik</h2>
                    <p>Platforma erişmek ve hizmetlerden faydalanmak için bir hesap oluşturmanız gerekebilir. Hesap oluştururken doğru ve güncel bilgiler vermeyi, şifrenizi gizli tutmayı ve hesabınız altında gerçekleşen tüm faaliyetlerden sorumlu olduğunuzu kabul edersiniz.</p>

                    <h2>4. Kullanıcı İçerikleri ve Sorumluluk</h2>
                    <p>Platforma yüklediğiniz tüm içeriklerin (fotoğraflar, videolar vb.) sorumluluğu size aittir. Yüklediğiniz içeriklerin yasa dışı, müstehcen, hakaret içeren veya başkalarının haklarını ihlal etmemesi gerekmektedir.</p>
                    <p>Anora Forever, sadece bir teknik altyapı sağlayıcısıdır. Etkinliğe katılan davetlilerin, görüntülerin sisteme yüklenmesi hususunda bilgilendirilmesi ve gerekli rızalarının alınması tamamen Etkinlik Sahibi'nin sorumluluğundadır. Etkinlik Sahibi, platformu kullanarak davetlilerine bu aydınlatmanın yapıldığını beyan ve taahhüt eder. Üçüncü şahıslardan gelebilecek veri gizliliği veya telif itirazlarında Anora Forever'ın hiçbir hukuki sorumluluğu bulunmamaktadır.</p>

                    <h2>5. Ücretlendirme ve Ödemeler</h2>
                    <p>Platformda sunulan hizmetler (paketler, baskı ürünleri vb.) ücretlidir. Ücretlendirme ve ödeme koşulları, satın alım sürecinde size sunulacaktır. Yapılan ödemeler genellikle iade edilmez, bu konuda daha fazla bilgi için bizimle iletişime geçebilirsiniz.</p>

                    <h2>6. Fikri Mülkiyet Hakları</h2>
                    <p>Platformdaki tüm metinler, grafikler, logolar ve yazılımlar dahil olmak üzere tüm materyaller, Şirketimizin veya lisans verenlerimizin mülkiyetindedir ve ilgili fikri mülkiyet yasaları ile korunmaktadır.</p>

                    <h2>7. Sorumluluk Reddi</h2>
                    <p>Platformu kullanımınız tamamen sizin sorumluluğunuzdadır. Hizmetler "olduğu gibi" sunulmaktadır. Şirketimiz, hizmetlerin kesintisiz veya hatasız olacağına dair herhangi bir garanti vermez.</p>

                    <h2>8. Koşulların Değiştirilmesi</h2>
                    <p>Şirketimiz, bu Kullanım Koşulları'nı dilediği zaman değiştirme hakkını saklı tutar. Değişiklikler, platformda yayınlandığında yürürlüğe girer. Bu sayfayı düzenli olarak kontrol etmeniz önerilir.</p>

                    <h2>9. Yürürlükteki Kanunlar</h2>
                    <p>Bu Kullanım Koşulları, Türkiye Cumhuriyeti yasalarına tabi olacaktır. Bu koşullardan kaynaklanan herhangi bir uyuşmazlık, İstanbul mahkemelerinin münhasır yargı yetkisine tabi olacaktır.</p>

                    <h2>10. İletişim</h2>
                    <p>
                        Bu Kullanım Koşulları ile ilgili herhangi bir sorunuz varsa, bizimle aşağıdaki bilgiler üzerinden iletişime geçebilirsiniz:
                    </p>
                    <ul>
                        <li><strong>Şirket Adı:</strong>  ANORA FOREVER YAZILIM VE REKLAM ORGANİZASYON LİMİTED ŞİRKETİ</li>
                        <li><strong>Şirket Adresi:</strong> SULTAN SELİM MAH. ESKİ BÜYÜKDERE CAD. NO: 61 İÇ KAPI NO: 2 KAĞITHANE / İSTANBUL</li>
                        <li><strong>E-posta:</strong> <a href="mailto:info@anoraforever.com">info@anoraforever.com</a></li>
                    </ul>
                </article>
                <div className="flex justify-center mt-12 mb-8">
                    <button
                        onClick={() => navigate(-1)}
                        className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-rose-200 text-rose-600 font-medium hover:bg-rose-50 transition-all"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Geri dön
                    </button>
                </div>
            </div>
        </div>
    );
}